import React, { useEffect, useState } from 'react'
import { Container, Tab, Tabs, Card, Button, Row, Col, Badge, CardImg } from 'react-bootstrap'
import Tsn from '../../models/Tsn'
import Palette from '../../Palette'
import { useHistory, Link } from 'react-router-dom'
import TextFormatter from '../../util/TextFormatter'
import Member from "../../models/Member";
import moment from "moment";
import Swal from 'sweetalert2'

export default function TsnListPage() {
    const TAB_UPCOMING = 'UPCOMING'
    const TAB_REGISTERED = 'REGISTERED'
    const TAB_TERMS = 'TERMS'
    const history = useHistory()
    const [tsnData, setTsnData] = useState([])
    const [registeredTsnData, setRegisteredTsnData] = useState([])
    const [activeTab, setActiveTab] = useState(TAB_UPCOMING)
    const [loading, setLoading] = useState(false)

    const fetchUpcomingTsn = async () => {
        setLoading(true)

        try {
            let memberModel = new Member()
            let result = await memberModel.getActiveMembership()

            if(moment(result?.latestRegardlessOfValidity?.valid_until).isBefore(new Date())){
                await Swal.fire({
                    title: 'Harap memproses keanggotaan saudara',
                    text: 'Keanggotaan saudara harus aktif untuk mendaftar di TSN',
                    icon: 'info',
                    confirmButtonText: 'Oke',
                })
                history.push('/member/membership')
            }

        }catch (e) {

        }

        try {
            const result = await Tsn.getAll({
                show_details: false,
                availability_conditions: 'UPCOMING',
            })
            setTsnData(result || [])
        } catch (error) {
            console.error('Error fetching TSN data:', error ? error.message : 'Unknown error')
            setTsnData([])
        } finally {
            setLoading(false)
        }
    }

    const fetchRegisteredTsn = async () => {
        setLoading(true)
        try {
            const result = await Tsn.getSelf({
                group_by: 'tsn_id',
            })
            setRegisteredTsnData(result || [])
        } catch (error) {
            console.error(
                'Error fetching registered TSN data:',
                error ? error.message : 'Unknown error',
            )
            setRegisteredTsnData([])
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        const isLoggedIn = !!localStorage.getItem('user')
        if (!isLoggedIn) {
            history.replace('/login')
        }
    }, [history])

    useEffect(() => {
        fetchUpcomingTsn()
    }, [])

    const handleTabSelect = (key) => {
        setActiveTab(key)
        if (key === TAB_REGISTERED && registeredTsnData.length === 0) {
            fetchRegisteredTsn()
        } else if (key === TAB_UPCOMING && tsnData.length === 0) {
            fetchUpcomingTsn()
        }
    }

    // Format date as "DD MMMM YYYY"
    function formatDate(dateString) {
        if (!dateString) return '-'
        const date = new Date(dateString)
        if (isNaN(date)) return '-'
        const months = [
            'Januari',
            'Februari',
            'Maret',
            'April',
            'Mei',
            'Juni',
            'Juli',
            'Agustus',
            'September',
            'Oktober',
            'November',
            'Desember',
        ]
        const day = String(date.getDate()).padStart(2, '0')
        const month = months[date.getMonth()]
        const year = date.getFullYear()
        return `${day} ${month} ${year}`
    }

    const TsnCards = ({ data }) => (
        <Col lg={4} md={6} className="mb-4">
            <Card className="h-100 shadow-sm position-relative">
                <CardImg style={{ maxHeight: 250, objectFit: 'contain' }} src={data?.image_url} />

                <Card.Body className="d-flex flex-column">
                    <Card.Title
                        className="mb-3 fw-semibold"
                        style={{ fontSize: '18px', color: Palette.PRIMARY }}
                    >
                        {data?.name || '-'}
                    </Card.Title>

                    <Card.Text className="">
                        {formatDate(data?.start_time) === formatDate(data?.end_time)
                            ? formatDate(data?.start_time)
                            : `${formatDate(data?.start_time)} - ${formatDate(data?.end_time)}`}
                    </Card.Text>

                    <Row className="mb-3 g-2">
                        <Col xs={6}>
                            <div
                                className="rounded py-1 text-center"
                                style={{
                                    minHeight: '40px',
                                    background: Palette.LIGHT_GRAY,
                                    border: `1px solid ${Palette.PRIMARY}`,
                                    borderRadius: 10,
                                }}
                            >
                                <small className="text-muted d-block">Lokasi</small>
                                <strong className="small">{data?.location}</strong>
                            </div>
                        </Col>
                        <Col xs={6}>
                            <div
                                className="rounded py-1 text-center"
                                style={{
                                    minHeight: '40px',
                                    background: Palette.LIGHT_GRAY,
                                    border: `1px solid ${Palette.PRIMARY}`,
                                    borderRadius: 10,
                                }}
                            >
                                <small className="text-muted d-block">Biaya</small>
                                <strong className="small">{`Rp${TextFormatter.moneyFormatter(
                                    data?.price,
                                )}`}</strong>
                            </div>
                        </Col>
                    </Row>

                    <Button
                        style={{
                            fontFamily: 'Signika',
                            fontWeight: '600',
                            width: '100%',
                            fontSize: '16px',
                            backgroundColor: Palette.PRIMARY,
                            borderColor: Palette.PRIMARY,
                        }}
                        variant="primary"
                        className="mt-3 px-5 py-2"
                        href={`/tsn/${data.id}`}
                        size="lg"
                    >
                        Selengkapnya
                    </Button>
                </Card.Body>
            </Card>
        </Col>
    )

    const getCurrentData = () => {
        return activeTab === TAB_REGISTERED ? registeredTsnData : tsnData
    }

    const EmptyState = ({ type }) => (
        <div className="text-center py-5 w-100">
            <h5 className="mb-2" style={{ color: Palette.PRIMARY }}>
                {type === 'upcoming' ? 'Tidak Ada TSN Mendatang' : 'Belum Ada TSN Terdaftar'}
            </h5>
            <p className="text-muted mb-3">
                {type === 'upcoming'
                    ? 'Saat ini tidak ada TSN yang tersedia. Silakan cek kembali nanti.'
                    : 'Anda belum mendaftar ke TSN manapun.'}
            </p>
            {type === 'registered' && (
                <Button
                    variant="outline-primary"
                    onClick={() => setActiveTab(TAB_UPCOMING)}
                    style={{ borderColor: Palette.PRIMARY, color: Palette.PRIMARY }}
                >
                    Lihat TSN Mendatang
                </Button>
            )}
        </div>
    )

    const LoadingState = () => (
        <div className="text-center py-5 w-100">
            <div className="spinner-border" style={{ color: Palette.PRIMARY }} role="status"></div>
            <p className="text-muted mt-3">Memuat data TSN...</p>
        </div>
    )

    const renderTabContent = () => {
        if (loading) {
            return <LoadingState />
        }

        const currentData = getCurrentData()

        if (!currentData || currentData.length === 0) {
            return <EmptyState type={activeTab === TAB_UPCOMING ? 'upcoming' : 'registered'} />
        }

        return (
            <Row>
                {currentData.map((tsnObject) => (
                    <TsnCards key={tsnObject.id} data={tsnObject} />
                ))}
            </Row>
        )
    }

    return (
        <Container className="text-left py-4">
            <Tabs activeKey={activeTab} onSelect={handleTabSelect} className="mb-4">
                <Tab eventKey={TAB_UPCOMING} title="Mendatang">
                    {renderTabContent()}
                </Tab>

                <Tab eventKey={TAB_REGISTERED} title="Telah Terdaftar">
                    {renderTabContent()}
                </Tab>
                <Tab eventKey={TAB_TERMS} title="Syarat dan Ketentuan">
                    <Container>
                        <Row className="page-title">Syarat dan Ketentuan Pendaftaran</Row>

                        <Row>
                            <Col xl={12} lg={12} md={12} xs={12} className={'m-auto'}>
                                <br/><div style={{fontWeight : "bold", fontSize : "1.2em"}}>Tes Sertifikasi Nasional Himpunan Penerjemah Indonesia 2026</div>
                                Syarat dan Ketentuan berikut mengatur pendaftaran diri Anda sebagai peserta Tes Sertifikasi Nasional Himpunan Penerjemah Indonesia (TSN HPI) 2026 yang diselenggarakan oleh Himpunan Penerjemah Indonesia (HPI). Dengan melakukan pendaftaran, Anda dianggap telah membaca, memahami, dan menyetujui seluruh ketentuan di bawah ini.<br/>
                                <br/><div style={{fontWeight : "bold", fontSize : "1.2em"}}>1. Persyaratan Peserta</div>
                                Pendaftaran hanya terbuka bagi anggota aktif HPI dengan status keanggotaan Profesional atau Aspiran. Khusus untuk TSN HPI Editor Terjemahan, hanya Anggota HPI yang telah lulus TSN HPI Penerjemahan yang dapat mengikutinya. HPI berhak melakukan verifikasi status keanggotaan peserta kapan pun selama proses pendaftaran dan pelaksanaan ujian berlangsung.<br/>
                                <br/><div style={{fontWeight : "bold", fontSize : "1.2em"}}>2. Batas Waktu dan Biaya Pendaftaran</div>
                                Terdapat dua jenis batas waktu dan biaya pendaftaran di TSN HPI 2026:<br/>
                                &nbsp;&nbsp;&nbsp;&nbsp;&bull; TSN HPI untuk Penerjemah dan Editor Terjemahan<br/>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Batas Waktu Pendaftaran: 17 Juli 2026, pukul 23.59 WIB<br/>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Biaya per Mata Uji: Rp2.250.000<br/>
                                &nbsp;&nbsp;&nbsp;&nbsp;&bull; TSN HPI untuk Juru Bahasa<br/>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Batas Waktu Pendaftaran: 24 Juli 2026, pukul 23.59 WIB<br/>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Biaya per Mata Uji: Rp4.000.000<br/>
                                Pendaftaran dinyatakan sah apabila pembayaran telah diterima secara penuh sebelum batas waktu yang ditentukan.<br/>
                                <br/><div style={{fontWeight : "bold", fontSize : "1.2em"}}>3. Platform Pendaftaran</div>
                                Platform pendaftaran, termasuk pembayaran biaya pendaftaran, TSN HPI 2026 adalah Sihapei. Calon peserta mendaftar dengan terlebih dahulu masuk ke akun Sihapei-nya sendiri. Pendaftaran dan pembayaran biaya pendaftaran di luar Sihapei tidak diterima.<br/>
                                <br/><div style={{fontWeight : "bold", fontSize : "1.2em"}}>4. Kebijakan Pembatalan dan Pengembalian
                                Dana</div>
                                Peserta yang ingin membatalkan pendaftarannya dapat mengajukan permohonan tertulis melalui email sebelum batas waktu pendaftaran yang berlaku. Kebijakan pengembalian dana sebagai berikut:<br/>
                                &nbsp;&nbsp;&nbsp;&nbsp;&bull; Pengembalian 50%: Untuk permohonan pembatalan yang diterima melalui surel Sekretariat HPI paling lambat pukul 23.59 WIB pada tanggal batas waktu pendaftaran masing-masing jenis ujian.<br/>
                                &nbsp;&nbsp;&nbsp;&nbsp;&bull; Tanpa Pengembalian Dana: Untuk permohonan pembatalan yang diterima setelah batas waktu pendaftaran masing-masing jenis ujian.<br/>
                                Proses pengembalian dana akan dilakukan dalam waktu maksimal 14 (empat belas) hari kerja setelah permohonan disetujui dengan metode transfer bank. Sekretariat HPI akan menghubungi calon peserta melalui surel untuk keperluan ini.<br/>
                                <br/><div style={{fontWeight : "bold", fontSize : "1.2em"}}>5. Jadwal Ujian dan Penjadwalan Ulang</div>
                                Jadwal ujian telah ditentukan dan tidak dapat diubah. Tidak ada kebijakan penjadwalan ulang dalam bentuk apa pun.<br/>
                                <br/><div style={{fontWeight : "bold", fontSize : "1.2em"}}>6. Keputusan Hasil Ujian</div>
                                Hasil ujian yang dikeluarkan oleh HPI bersifat final dan mengikat. Tidak tersedia mekanisme banding, sanggahan, atau permintaan peninjauan ulang.<br/>
                                <br/><div style={{fontWeight : "bold", fontSize : "1.2em"}}>7. Kode Etik Peserta</div>
                                Seluruh peserta ujian wajib menjaga integritas profesional dan mematuhi kode etik HPI selama pelaksanaan ujian. Pelanggaran seperti kecurangan, penyamaran, atau tindakan mengganggu akan mengakibatkan diskualifikasi langsung dan hangusnya biaya pendaftaran.<br/>
                                <br/><div style={{fontWeight : "bold", fontSize : "1.2em"}}>8. Batasan Tanggung Jawab</div>
                                HPI tidak bertanggung jawab atas kehilangan pribadi, kendala teknis, atau keadaan di luar kendali yang dapat memengaruhi kemampuan peserta untuk mengikuti ujian. HPI akan berupaya memberikan informasi terkini melalui saluran resmi.<br/>
                                <br/><div style={{fontWeight : "bold", fontSize : "1.2em"}}>9. Privasi dan Penggunaan Data</div>
                                Data pribadi yang diberikan dalam proses pendaftaran akan digunakan semata-mata untuk keperluan administrasi ujian dan sertifikasi, sesuai dengan kebijakan privasi HPI dan peraturan perundang-undangan yang berlaku di Indonesia.<br/>
                                <br/><div style={{fontWeight : "bold", fontSize : "1.2em"}}>10. Hukum yang Berlaku</div>
                                Syarat dan Ketentuan ini tunduk pada dan ditafsirkan sesuai dengan hukum yang berlaku di wilayah hukum Republik Indonesia.
                            </Col>
                        </Row>
                    </Container>
                </Tab>
            </Tabs>
        </Container>
    )
}
